import React from 'react';
import { motion } from 'framer-motion';
import { FaBriefcase, FaCalendarAlt, FaMapMarkerAlt } from 'react-icons/fa';
import './Experience.css';

const experiences = [
  {
    company: 'Palm Mind Technology',
    role: 'Junior AI Engineer',
    type: 'Onsite',
    location: 'Nepal',
    period: 'Nov 2025 – Jan 2026',
    description:
      'Built RAG chatbots, developed evaluation pipelines, and created a gym assistant AI agent.',
  },
  {
    company: 'Wiseyak',
    role: 'Junior AI Engineer',
    type: 'Onsite',
    location: 'Nepal',
    period: 'Jan 2025 – Aug 2025',
    description:
      'Built AI agents for healthcare applications and chatbots for banking services.',
  },
];

const Experience = () => {
  return (
    <section id="experience" className="experience">
      <div className="container">
        <div className="section-header">
          <span className="section-label">{'// Career'}</span>
          <h2 className="section-title">Work Experience</h2>
        </div>

        <div className="experience__timeline">
          <div className="experience__line" />
          {experiences.map((exp, idx) => (
            <motion.div
              className="experience__item"
              key={idx}
              initial={{ opacity: 0, x: idx % 2 === 0 ? -40 : 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.2 }}
            >
              <div className="experience__dot" />
              <div className="experience__card">
                <div className="experience__card-header">
                  <div>
                    <h3 className="experience__role">{exp.role}</h3>
                    <h4 className="experience__company">
                      <FaBriefcase /> {exp.company}
                    </h4>
                  </div>
                  <span className="experience__type">{exp.type}</span>
                </div>
                <div className="experience__meta">
                  <span><FaCalendarAlt /> {exp.period}</span>
                  <span><FaMapMarkerAlt /> {exp.location}</span>
                </div>
                <p className="experience__desc">{exp.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
